<template>
  <trek-button
    v-bind="compareButtonIconProps"
    qaid="productCompareAddButton"
    :block="block"
    :text="!tertiary"
    :tertiary="tertiary"
    :small="small"
    @click.stop="onCompareClick"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <span v-html="compareButtonText"></span>
  </trek-button>
</template>
<script>
import {CompareButton} from '@/components/compare/mixins/compare-button';
import TrekButton from '@/components/TrekButton';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'ProductCompareButton',
  components: {TrekButton},
  mixins: [CompareButton],

  props: {
    product: {
      type: Object,
      required: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
    tertiary: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      imageUrl: '',
      productName: '',
      productUrl: '',
      productCode: '',
      baseProductId: '',
    };
  },

  mounted() {
    this.imageUrl = get(this.product, 'imageURLList[0]', '');

    if (!this.imageUrl && this.product && !isEmpty(this.product.images)) {
      let assetId = this.product.images[Object.keys(this.product.images)[0]][0].assetId;

      if (!isEmpty(assetId)) {
        this.imageUrl = `//trek.scene7.com/is/image/TrekBicycleProducts/${assetId}?wid=1360&hei=1020&fmt=pjpeg&qlt=40,1&iccEmbed=0&cache=on,on`;
      }
    }

    this.productName = this.product.displayName || this.product.name;
    this.productUrl = this.product.url || window.location.pathname;
    this.baseProductId = this.productCode = this.product.code;
  },
};
</script>
